import { render, staticRenderFns } from "./attendanceCertification.vue?vue&type=template&id=69b9a449&scoped=true"
import script from "./attendanceCertification.vue?vue&type=script&lang=js"
export * from "./attendanceCertification.vue?vue&type=script&lang=js"
import style0 from "./attendanceCertification.vue?vue&type=style&index=0&id=69b9a449&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69b9a449",
  null
  
)

export default component.exports